import { t } from "@lingui/macro";
import { atom, useAtomValue, useSetAtom } from "jotai";
import { ScrollView } from "react-native";

import { Button } from "@whoosh/design-system/src/components/controls";
import { Text, VStack } from "@whoosh/design-system/src/components/primitive";

import { ProceedToActivateAccountStepAtom } from "../../../../atoms/actions";
import { VerificationModalStepStateAtom } from "../../../../atoms/stores";

const verificationStepDataAtom = atom((get) => {
  const state = get(VerificationModalStepStateAtom);
  if (state.step === "AccountNotFound") {
    return state;
  }
  return null;
});

export const AccountNotFoundStep = () => {
  const verificationStepData = useAtomValue(verificationStepDataAtom);
  const goToActivateAccount = useSetAtom(ProceedToActivateAccountStepAtom);

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <VStack paddingHorizontal={6} paddingBottom={6} flexGrow={1}>
        <VStack gap={4}>
          <Text variant={"mainTitle2"}>{t`No Account Found`}</Text>
          <Text variant="mainBaseMedium" color="text-secondary">
            {t`We couldn't find a user for ${
              verificationStepData?.email ?? verificationStepData?.phone ?? ""
            }.`}
          </Text>
        </VStack>
        <VStack my={6}>
          <Text variant="mainBaseSemiBold" mb={3}>
            {t`Private Clubs`}
          </Text>
          <Button
            accessibilityLabel={t`Activate your account button`}
            onPress={() =>
              goToActivateAccount({ email: verificationStepData?.email ?? "" })
            }
          >{t`Activate your account`}</Button>
        </VStack>
        <VStack>
          <Text variant="mainBaseSemiBold" mb={3}>
            {t`Public Clubs`}
          </Text>
          <Text variant="mainBaseMedium" color="text-secondary">
            {t`You can sign up to book on a public facility by accessing their tee sheet directly from their website.`}
          </Text>
        </VStack>
      </VStack>
    </ScrollView>
  );
};
